import React from 'react';
import { motion } from 'framer-motion';
import { trackLocalSEO } from '../utils/analytics';
import './GoogleMap.css';

const GoogleMap = () => {
  return (
    <motion.div 
      className="google-map-container"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <div className="map-header">
        <h3>Find Us on Google Maps</h3>
        <p>Ram Devi Complex, Suryabinayak, Bhaktapur</p>
      </div>
      
      <div className="map-wrapper">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3532.8947!2d85.4276!3d27.6710!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb176b23c5c4d9%3A0x4f8f8f8f8f8f8f8f!2sRam%20Devi%20Complex%2C%20Suryabinayak%2C%20Bhaktapur!5e0!3m2!1sen!2snp!4v1697000000000!5m2!1sen!2snp"
          width="100%"
          height="400"
          style={{ border: 0, borderRadius: '15px' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Premier Dental Clinic Location - Ram Devi Complex, Suryabinayak, Bhaktapur"
        ></iframe>
      </div>
      
      <div className="map-actions">
        <a 
          href="https://maps.app.goo.gl/bGFwrGwwvLSF4PrA8" 
          target="_blank" 
          rel="noopener noreferrer"
          className="btn btn-primary map-btn"
          onClick={() => trackLocalSEO.locationClick('google_maps_open')}
        >
          📍 Open in Google Maps
        </a>
        <a 
          href="https://maps.app.goo.gl/bGFwrGwwvLSF4PrA8" 
          target="_blank" 
          rel="noopener noreferrer"
          className="btn btn-secondary map-btn"
          onClick={() => trackLocalSEO.directionsClick()}
        >
          🧭 Get Directions
        </a>
      </div>
      
      <div className="location-details">
        <div className="location-item">
          <span className="location-icon">🏥</span>
          <div>
            <strong>Premier Dental Clinic</strong>
            <p>Best Dental Treatment in Bhaktapur</p>
          </div>
        </div>
        <div className="location-item">
          <span className="location-icon">📍</span>
          <div>
            <strong>Address</strong>
            <p>Ram Devi Complex, Suryabinayak, Bhaktapur 44800</p>
          </div>
        </div>
        <div className="location-item">
          <span className="location-icon">📞</span>
          <div>
            <strong>Contact</strong>
            <p>Mobile: +977 981-3538101</p>
            <p>Landline: 015924538</p>
          </div>
        </div>
        <div className="location-item">
          <span className="location-icon">🕒</span>
          <div>
            <strong>Hours</strong>
            <p>Daily: 8:00 AM - 7:00 PM</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default GoogleMap;
